<template>
  <div class="a-transition-fade m-card-primary m-login">
    <AtomLogoPrimary/>
    <form
      autocomplete="off"
      class="a-form-column"
      name="login-form"
      @submit.prevent="createUsuarioLogin"
    >
      <p
        v-if="loginError"
        class="font-weight-bold text-color-danger text-align-center"
      >
        Los datos ingresados son incorrectos.
      </p>
      <AtomInputPrimary
        v-model="login.email"
        name="usuario"
        :placeholder="'Usuario'"
        type="email"
      />
      <AtomInputPrimary
        v-model="login.password"
        name="contraseña"
        :placeholder="'Contraseña'"
        type="password"
      />
      <AtomButtonPrimary :button-primary="buttonPrimary"/>
    </form>
  </div>
</template>

<script>
export default {
  name: 'MoleculeLogin',

  data () {
    return {
      buttonPrimary: {
        action: 'ACCEDER',
        behavior: 'login',
        class: 'a-button-login text-transform-uppercase width-100-pr',
        sending: false,
        type: 'submit'
      },

      login: {
        email: '',
        password: ''
      },

      loginError: false
    }
  },

  methods: {
    createUsuarioLogin () {
      this.buttonPrimary.sending = true
      this.$services.create('usuario', 'createUsuarioLogin', this.login)
        .then(response => {
          let cognito = response.data
          console.log(cognito)
          if (!cognito.error) {
            this.$auth.handleAuthentication(cognito)
            this.loginError = false
          } else {
            this.loginError = true
            this.buttonPrimary.sending = false
          }
        })
        .catch(error => {
          console.log(error)
          this.buttonPrimary.sending = false
          this.loginError = true
        })
    }
  }
}
</script>
